import {Component , Inject , OnInit , ViewEncapsulation} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import {FrontUserService} from '../../../../core/services/frontUsers.service';
import jsPDF from 'jspdf';
import * as PDFObject from 'pdfobject';
import {CommunicationFormDialogComponent} from '../setting-form/setting-form.component';
import {DatePipe} from '@angular/common';
import {FuseConfigService} from '../../../../core/services/config.service';
import {OrganizationsService} from '../../../../core/services/organizations.service';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import * as docx from 'docx';
import * as fileSaver from 'file-saver';
import {DomSanitizer} from '@angular/platform-browser';
import {CommunicationService} from '../../../../core/services/communication.service';
import { MatChipInputEvent } from '@angular/material/chips';

@Component({
    selector: 'communication-form-dialog-copy',
    templateUrl: './setting-form.component.html',
    styleUrls: ['./setting-form.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})

export class CommunicationCopyFormDialogComponent implements OnInit {
  public formGroupMail: FormGroup = new FormGroup({
    mails: new FormControl(''),
    cc: new FormControl(''),
    bcc: new FormControl(''),
    subject: new FormControl('', Validators.required),
    body: new FormControl(''),
    description: new FormControl(''),
  });
  public formGroupSms: FormGroup = new FormGroup({
    description: new FormControl(''),
    numbers: new FormControl(''),
    text: new FormControl('')
  });
  public formGroupSerial: FormGroup = new FormGroup({
    description: new FormControl(''),
    users: new FormControl(''),
    text: new FormControl('')
  });
  cc = [];
  bcc = [];
  image64;
  public config = {
    editable: true ,
    spellcheck: true ,
    height: 'auto' ,
    minHeight: '150px' ,
    width: 'auto' ,
    minWidth: '0' ,
    translate: 'yes' ,
    enableToolbar: true ,
    showToolbar: true ,
    placeholder: 'Bitte hier die Nachricht eingeben...' ,
    imageEndPoint: '' ,
    toolbar: [
      [ 'bold' , 'italic' , 'underline' , 'strikeThrough' , 'superscript' , 'subscript' ] ,
      [ 'fontSize' ] ,
      [ 'justifyLeft' , 'justifyCenter' , 'justifyRight' , 'justifyFull' , 'indent' , 'outdent' ] ,
      [ 'delete' , 'removeFormat' ] ,
      [ 'paragraph' , 'blockquote' , 'removeBlockquote' , 'horizontalLine' , 'orderedList' , 'unorderedList' ]
    ]
  };
  quillConfig = [['bold', 'italic', 'underline', 'strike'],        // toggled buttons
    ['blockquote', 'code-block'],

    [{ 'header': 1 }, { 'header': 2 }],               // custom button values
    [{ 'list': 'ordered'}, { 'list': 'bullet' }],
    [{ 'script': 'sub'}, { 'script': 'super' }],      // superscript/subscript
    [{ 'indent': '-1'}, { 'indent': '+1' }],          // outdent/indent
    [{ 'direction': 'rtl' }],                         // text direction

    [{ 'size': ['small', false, 'large', 'huge'] }],  // custom dropdown
    [{ 'header': [1, 2, 3, 4, 5, 6, false] }],

    [{ 'color': new Array<any>() }, { 'background': new Array<any>() }],          // dropdown with defaults from theme
    [{ 'font': new Array<any>() }],
    [{ 'align': new Array<any>() }],

    ['clean']];
  action: string;
  dialogTitle;
  mails = [];
  mailBody: any = '';
  subject;
  body;
  mailBody1 = '';
  mailBody2 = '';
  mailBody3 = '';
  typeOfMessage = 'personal';
  organizationLogo = false;
  numbers = [];
  users = [];
  numbersForSend;
  usersForSend;
  usersData = [];
  userInfo;
  text = '';
  typeOfLetter = 'left';
  left = 27;
  top = 48;
  description = '';
  welcome;
  end;
  date;
  organization;
  organizationInfo;
  bodyWithOrgLogo;
  bodyWithOrgInfo;
  spec;
  id;
  proportion = 2;
  inviteUrl = false;
  websiteLink = 'https://www.pfefferstern.ch/';
  imgUrl = 'https://pfefferstern.s3.amazonaws.com/images/';
  fileUrls = '';
  showFullName = false;
  lang;
  inviteQrCodes: any = [];
  showInviteQrCodes = false;
  showRegisterQrCodes = false;
  registerQrCode;
  isOrgAdmin = false;

  constructor (public dialogRef: MatDialogRef<CommunicationFormDialogComponent> ,
               public dialog: MatDialog, public translate: TranslateService,
               @Inject(MAT_DIALOG_DATA) private data: any , public userService: FrontUserService ,
               private fuseConfig: FuseConfigService , private orgService: OrganizationsService,
               private toastr: ToastrService , private sanitizer: DomSanitizer,
               private communicationService: CommunicationService) {
    this.lang = this.translate.currentLang;
    this.fuseConfig.projectSettings.subscribe((res: any) => {
      if (res) {
        this.websiteLink = res.websiteLink;
        this.imgUrl = res.imageLink;
      }
    });
    this.fuseConfig.organizationId.subscribe(res => {
      if (res) {
        orgService.getOrganizationById(res).subscribe((result) => {
          this.organization = result;
          if (this.organization && this.organization.logo) {
            this.toDataURL(this.imgUrl + this.organization.logo, (dataUri) => {
              this.image64 = dataUri;
              let img = new Image();
              img.src = dataUri;
              let that = this;
              img.onload = function() {
                that.proportion =  img.width / img.height;
              };
            });
          }
        });
      }
    });
    this.action = data.action;
    this.description = data.description ? data.description : '';
    this.spec = data.spec;
    this.id = data.id;
    console.log(data);
    if (this.action === 'mail') {
      this.dialogTitle = 'communication.mail';
      this.mailBody1 = data.data.body1;
      this.mailBody2 = data.data.body2;
      this.mailBody3 = data.data.body3;
      this.body = data.data.body;
      this.subject = data.data.subject;
      this.typeOfMessage = data.data.typeOfMessage;
      this.showRegisterQrCodes = data.data.showQrCode;
      // this.showInviteQrCodes = data.data.showQrCode;
      if (data.data.mails) {
        this.mails = data.data.mails.split(',');
      }
      if (data.data.mailsForSendCC) {
        this.cc = data.data.mailsCC.split(',');
      }
      if (data.data.mailsForSendBCC) {
        this.bcc = data.data.mailsBCC.split(',');
      }
      let greeting = this.typeOfMessage !== 'family' ? 'Hallo fistName lastName,  ' : 'Familie lastName und fistName';
      this.mailBody = this.sanitizer.bypassSecurityTrustHtml(this.mailBody1 + (this.subject ? this.subject : '') +
        this.mailBody2 + greeting + (this.body ? this.body : '') + (this.fileUrls ? this.fileUrls : '') + this.mailBody3);
    }
    if (this.action === 'sms') {
      this.dialogTitle = 'communication.sms';
      if (data.data.numbers) {
        this.numbers = data.data.numbers.split(',');
      }
      this.text = data.data.text;
    }
    if (this.action === 'whatsapp') {
      this.dialogTitle = 'communication.whatsapp';
      if (data.data.numbers) {
        this.numbers = data.data.numbers.split(',');
      }
      this.text = data.data.text;
    }
    if (this.action === 'serial') {
      this.dialogTitle = 'communication.serial';
      this.text = data.data.text;
      this.welcome = data.data.welcome;
      this.end = data.data.end;
      this.date = data.data.date;
      this.organizationLogo = data.data.organizationLogo;
      this.showFullName = data.data.showFullName;
      this.inviteUrl = data.data.showUrl;
      // this.showInviteQrCodes = data.data.showQrCode;
      this.showRegisterQrCodes = data.data.showQrCode;
      if (data.data.users) {
        this.usersForSend = data.data.users.split(',');
        this.users = data.data.users.split(',');
      }
      this.userInfo = data.data.userInfo;
      this.getRegistrationQrCode();
      // this.getInviteQrCodes(this.userInfo);
      for (let i = 0; i < this.userInfo.length; i++) {
        this.usersData.push({
          value: this.userInfo[ i ].id ,
          label: this.userInfo[ i ].firstName + ' ' + this.userInfo[ i ].lastName
        });
      }
    }
  }

  ngOnInit () {
    this.fuseConfig.role.subscribe(res => {
      if (res && res === 'organisationAdmin') {
        this.isOrgAdmin = true;
      } else {
        this.isOrgAdmin = false;
      }
    });
    if (this.action === 'mail') {
      this.formGroupMail.patchValue({mails: this.mails});
      let mailsInput =  this.formGroupMail.get('mails');
      let ccInput = this.formGroupMail.get('cc');
      let bccInput = this.formGroupMail.get('bcc');
      if (this.spec === 'template') {
        mailsInput.disable({emitEvent: false});
        ccInput.disable({emitEvent: false});
        bccInput.disable({emitEvent: false});
      }
      // this.mailsForSend = this.mails;
      this.formGroupMail.patchValue({subject: this.subject});
      this.formGroupMail.get('subject').valueChanges.subscribe((res) => {
        this.subject = res;
        let greeting = this.typeOfMessage !== 'family' ? 'Hallo fistName lastName,  ' : 'Familie lastName und fistName';
        this.mailBody = this.sanitizer.bypassSecurityTrustHtml(this.mailBody1 + (this.subject ? this.subject : '') +
          this.mailBody2 + greeting + (this.body ? this.body : '') + (this.fileUrls ? this.fileUrls : '') + this.mailBody3);
      });

      // this.formGroupMail.get('mails').valueChanges.subscribe((res) => {
      //   this.mailsForSend = res;
      // });
      this.formGroupMail.patchValue({cc: this.cc});
      if (this.cc.length) {
        ccInput.patchValue(this.cc);
      }
      this.formGroupMail.get('cc').valueChanges.subscribe((res) => {
        this.cc = res;
      });
      this.formGroupMail.patchValue({bcc: this.bcc});
      if (this.bcc.length) {
        bccInput.patchValue(this.bcc);
      }
      this.formGroupMail.get('bcc').valueChanges.subscribe((res) => {
        this.bcc = res;
      });
      this.formGroupMail.patchValue({description: this.description});
      this.formGroupMail.get('description').valueChanges.subscribe((res) => {
        this.description = res;
      });
    }
    if (this.action === 'sms' || this.action === 'whatsapp') {
      this.formGroupSms.patchValue({numbers: this.numbers});
      this.formGroupSms.patchValue({text: this.text});
      let mailsInput = this.formGroupSms.get('numbers');
      if (this.spec === 'template') {
        mailsInput.disable({emitEvent: false});
      }
      mailsInput.patchValue(this.numbers);
      this.numbersForSend = this.numbers;
      this.formGroupSms.get('numbers').valueChanges.subscribe((res) => {
        this.numbersForSend = res;
      });
      this.formGroupSms.get('text').valueChanges.subscribe((res) => {
        this.text = res;
      });
      this.formGroupSms.patchValue({description: this.description});
      this.formGroupSms.get('description').valueChanges.subscribe((res) => {
        this.description = res;
      });
    }
    if (this.action === 'serial') {
      let usersSelect = this.formGroupSerial.get('users');
      if (this.spec === 'template') {
        usersSelect.disable({emitEvent: false});
      }
      usersSelect.patchValue(this.usersData);
      this.formGroupSerial.patchValue({users: this.users});
      this.formGroupSerial.patchValue({text: this.text});
      this.formGroupSerial.get('users').valueChanges.subscribe((res) => {
        this.usersForSend = res;
        this.downloadPDF(false);
      });
      this.formGroupSerial.get('text').valueChanges.subscribe((res) => {
        this.text = res;
      });
      this.formGroupSerial.patchValue({description: this.description});
      this.formGroupSerial.get('description').valueChanges.subscribe((res) => {
        this.description = res;
      });
      setTimeout(() => {
        this.downloadPDF(false);
      } , 3000);

    }

  }

  onChange (event) {
    this.body = event;
    let greeting = this.typeOfMessage !== 'family' ? 'Hallo fistName lastName,  ' : 'Familie lastName und fistName';
    this.mailBody = this.sanitizer.bypassSecurityTrustHtml(this.mailBody1 + (this.subject ? this.subject : '') +
      this.mailBody2 + greeting + (this.body ? this.body : '') + (this.fileUrls ? this.fileUrls : '') + this.mailBody3);
  }

  updateData(e) {
    this.fileUrls = '';
    let greeting = this.typeOfMessage !== 'family' ? 'Hallo fistName lastName,  ' : 'Familie lastName und fistName';
    if (e && e.files && e.files.length) {
      for (let i = 0; i < e.files.length; i++) {
        this.fileUrls = this.fileUrls + `<p><a href="${e.files[i].url}" target="_blank" rel="noopener noreferrer" download>${e.files[i].name}</a></p>`;
      }
      this.mailBody = this.sanitizer.bypassSecurityTrustHtml(this.mailBody1 + (this.subject ? this.subject : '') +
        this.mailBody2 + greeting + (this.body ? this.body : '') + (this.fileUrls ? this.fileUrls : '') + this.mailBody3);
    }
  }

  sendEmail () {
    console.log(this.typeOfMessage);
    this.userService.addCommunicationMail({
      description: this.description ,
      typeOfMessage: this.typeOfMessage ,
      mails: this.mails.toString() ,
      mailsBCC: this.bcc ? this.bcc.toString() : '',
      mailsCC: this.cc ? this.cc.toString() : '',
      subject: this.subject ,
      body: (this.body && this.body !== 'undefined' ? this.body : '') + this.fileUrls,
      body1: this.mailBody1 ,
      body2: this.mailBody2 ,
      body3: this.mailBody3 ,
      showQrCode: this.showRegisterQrCodes
    }).subscribe((res) => {
      if (res) {
        this.toastr.success('Email sent' , 'Success!' );
        this.dialogRef.close([]);
      }
    });
  }

  sendSMS () {
    console.log(this.typeOfMessage);
    this.userService.addCommunicationSMS({
      description: this.description ,
      text: this.text ,
      numbers: this.numbersForSend.toString()
    }).subscribe((res) => {
      if (res) {
        this.toastr.success('SMS sent' , 'Success!');
        this.dialogRef.close([]);
      }
    });
  }

  sendSerial () {
    this.downloadPDF(true);
    console.log(this.typeOfMessage);
    this.userService.addCommunicationSerial({
      description: this.description ,
      text: this.text ,
      users: this.usersForSend.toString() ,
      end: this.end ,
      welcome: this.welcome ,
      date: this.date ,
      organizationLogo: this.organizationLogo ,
      userInfo: this.userInfo,
      showFullName: this.showFullName,
      showUrl: this.inviteUrl,
      showQrCode: this.showRegisterQrCodes
    }).subscribe((res) => {
      this.toastr.success('Serial letter saved' , 'Success!');
      this.dialogRef.close([]);
    });
  }

  typeOfLetterChanges() {
    if (this.typeOfLetter === 'left') {
      this.left = 27;
      this.top = 48;
    }
    if (this.typeOfLetter === 'right') {
      this.left = 140;
      this.top = 110;
    }
    this.downloadPDF(false);
  }

  changeType(event) {
    let greeting = event !== 'family' ? 'Hallo fistName lastName,  ' : 'Familie lastName und fistName';
    this.mailBody = this.sanitizer.bypassSecurityTrustHtml((this.organizationLogo ? this.bodyWithOrgLogo : this.mailBody1  ) + (this.subject ? this.subject : '') +
      this.mailBody2 + greeting + (this.body ? this.body : '') + (this.fileUrls ? this.fileUrls : '') +
      (this.organizationInfo ? this.bodyWithOrgInfo : this.mailBody3));
  }

  downloadPDF (save) {
    let fontSize = 10;
    let textBody = '';
    const doc = new jsPDF();
    let imageSrc = '';
    let prorportionData = 2;
    if (save) {
      imageSrc = this.image64;
      prorportionData = this.proportion;
    } else {
      imageSrc = this.image64;
      prorportionData = this.proportion;
    }
    if (this.end) {
      textBody = (this.text ? this.text : '') + '\n\n' + this.end;
    } else {
      textBody = this.text ? this.text : '';
    }
    if (this.usersForSend) {
      for (let i = 0; i < this.usersForSend.length; i++) {
        if (this.organizationLogo && this.organization && this.organization.logo && imageSrc) {
          let x = this.left ? +this.left : 0;
          doc.addImage(  imageSrc, 'JPEG' , x , 20, 20 * prorportionData, 20);
        }
        let ofsetTop = this.top + fontSize / 4;
        doc.setFontSize(fontSize).setFont('normal');
        let user = this.userInfo.filter(obj => {
          return +obj.id === +this.usersForSend[ i ];
        });
        if (user && user[0]) {
          doc.text(user[ 0 ].lastName ? user[ 0 ].lastName : ''
          + ' ' + user[ 0 ].firstName ? user[ 0 ].firstName : '', this.left ? this.left : 0 , ofsetTop);
          ofsetTop = ofsetTop + fontSize / 2;
          doc.text(user[ 0 ].street ? user[ 0 ].street : ''
          + ' ' + user[ 0 ].number ? user[ 0 ].number : '', this.left ? this.left : 0 , ofsetTop);
          ofsetTop = ofsetTop + fontSize / 2;
          doc.text(user[ 0 ].postcode ? user[ 0 ].postcode : ''
          + ' ' + (user[ 0 ].cityLocation ? user[ 0 ].cityLocation : user[ 0 ].cityName), this.left ? this.left : 0 , ofsetTop);

          if (this.date) {
            const pipe = new DatePipe('de-CH');
            const dateFormated = pipe.transform(this.date , 'dd.LLLL yyyy');
            ofsetTop = ofsetTop + fontSize * 2;
            doc.text(dateFormated, 25 , ofsetTop);
          }

          if (this.welcome) {
            ofsetTop = ofsetTop + 20;
            if (this.showFullName) {
              doc.text(this.welcome + ' ' + user[ 0 ].firstName + ' ' + user[ 0 ].lastName, 25 , ofsetTop);
            } else {
              doc.text(this.welcome + ' ' + user[ 0 ].firstName, 25 , ofsetTop);
            }
          } else {
            ofsetTop = ofsetTop + 20;
          }
          if (this.inviteUrl) {
            if (user[ 0 ].activeCode) {
              let _text = this.translate.instant('active_code_information');
              textBody = textBody + '\n\n' + _text;
            } else {
              let _text = this.translate.instant('no_active_code_information');
              textBody = textBody + '\n\n' + _text;
            }
          }
          textBody = textBody ? textBody : '';
          ofsetTop = ofsetTop + 5;
          let textLines = doc
            .setFontSize(10)
            .splitTextToSize(textBody , 150);
          doc.text(textLines , 25 , ofsetTop);
          ofsetTop = ofsetTop + 5 * textLines.length;

          if (this.inviteUrl && user[ 0 ].activeCode) {
            textBody = user[ 0 ].activeCode;
            ofsetTop = ofsetTop + 5;

            textLines = doc
              .setFontSize(14)
              .setFont('bold')
              .splitTextToSize(textBody , 150);
            doc.text(textLines , 25 , ofsetTop);
          }
          if (this.end) {
            textBody = '\n\n' + this.end;
            textLines = doc
              .setFontSize(10)
              .setFont('normal')
              .splitTextToSize(textBody , 150);
            ofsetTop = ofsetTop + 5;
            doc.text(textLines , 25, ofsetTop);
          }
          if (this.showRegisterQrCodes) {
            if (this.registerQrCode) {
              doc.setTextColor('black');
              doc.addImage(this.registerQrCode , 'JPEG' , 140 , 220 , 60 , 60);
            }
          }
        }


        if (i !== this.usersForSend.length - 1) {
          doc.addPage('a4');
        }
      }
    }


    if (this.spec === 'template') {
      if (this.organizationLogo && this.organization && this.organization.logo) {
        doc.addImage(this.imgUrl + this.organization.logo , 'JPEG' , 5 , 5, 100, 100);
      }
      let ofsetTop = this.top + fontSize / 4;
      doc.setFontSize(fontSize);


      doc.text('****' + ' ' + '****', this.left , ofsetTop);
      ofsetTop = ofsetTop + fontSize / 2;
      doc.text('******' + ' ' + '**', this.left , ofsetTop);
      ofsetTop = ofsetTop + fontSize / 2;
      doc.text('******' + ' ' + '******', this.left , ofsetTop);

      if (this.date) {
        const pipe = new DatePipe('de-CH');
        const dateFormated = pipe.transform(this.date , 'dd.LLLL yyyy');
        ofsetTop = ofsetTop + fontSize * 2;
        doc.text(dateFormated, 25 , ofsetTop);
      }

      if (this.welcome) {
        ofsetTop = ofsetTop + 20;
        doc.text(this.welcome + ' ' + '****', 25 , ofsetTop);
      } else {
        ofsetTop = ofsetTop + 20;
      }

      textBody = textBody ? textBody : '';
      let textLines = doc
        .setFontSize(10)
        .splitTextToSize(textBody , 150);

      ofsetTop = ofsetTop + 5;
      doc.text(textLines , 25 , ofsetTop);
    }

    if (save) {
      doc.save('serialLetter.pdf');
    } else {
      PDFObject.embed(doc.output('datauristring') , '#example1');
    }
  }

  downloadDOCX() {
    let doc: any = new docx.Document();
    let textBody = '';
    let imageSrc = `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`;
    if (this.image64) {
      imageSrc = this.image64.split(',')[1];
    }
    let prorportionData = this.proportion;
    let Buffer = require('buffer').Buffer;
    doc.Styles.createParagraphStyle('norm', 'Normal')
      .basedOn('Normal')
      .next('Normal')
      .size(28);
    if (this.usersForSend) {
      for (let i = 0; i < this.usersForSend.length; i++) {
        textBody = this.text ? this.text : '';
        let user = this.userInfo.filter(obj => {
          return +obj.id === +this.usersForSend[ i ];
        });
        if (user.length) {
          if (this.image64) {
            doc.createImage(Buffer.from(imageSrc, 'base64'), (80 * prorportionData), 80);
            let paragraph =  new docx.Paragraph('');
            doc.addParagraph(paragraph);
            paragraph =  new docx.Paragraph('');
            doc.addParagraph(paragraph);
          } else {
            doc.createImage(Buffer.from(imageSrc, 'base64'), 452, 76);
            let paragraph =  new docx.Paragraph('');
            doc.addParagraph(paragraph);
            paragraph =  new docx.Paragraph('');
            doc.addParagraph(paragraph);
          }
          let paragraph = new docx.Paragraph( user[ 0 ].lastName + ' ' + user[ 0 ].firstName).style('norm');
          if (this.typeOfLetter === 'right') {
            paragraph.right();
          }
          doc.addParagraph(paragraph);
          paragraph =  new docx.Paragraph(user[ 0 ].street + ' ' + user[ 0 ].number);
          if (this.typeOfLetter === 'right') {
            paragraph.right();
          }
          doc.addParagraph(paragraph);
          paragraph =  new docx.Paragraph(user[ 0 ].postcode + ' ' + user[ 0 ].cityLocation);
          if (this.typeOfLetter === 'right') {
            paragraph.right();
          }
          doc.addParagraph(paragraph);
          paragraph =  new docx.Paragraph('');
          doc.addParagraph(paragraph);
          paragraph =  new docx.Paragraph('');
          doc.addParagraph(paragraph);
          paragraph =  new docx.Paragraph('');
          doc.addParagraph(paragraph);
          if (this.date) {
            const pipe = new DatePipe('de-CH');
            const dateFormated = pipe.transform(this.date , 'dd.LLLL yyyy');
            paragraph =  new docx.Paragraph(dateFormated);
            doc.addParagraph(paragraph);
            paragraph =  new docx.Paragraph('');
            doc.addParagraph(paragraph);
            paragraph =  new docx.Paragraph('');
            doc.addParagraph(paragraph);
            paragraph =  new docx.Paragraph('');
            doc.addParagraph(paragraph);
          }
          if (this.welcome) {
            if (this.showFullName) {
              paragraph =  new docx.Paragraph(this.welcome + ' ' + user[ 0 ].firstName + ' ' + user[ 0 ].lastName);
              doc.addParagraph(paragraph);
            } else {
              paragraph =  new docx.Paragraph(this.welcome + ' ' + user[ 0 ].firstName);
              doc.addParagraph(paragraph);
            }
          }
          if (textBody) {
            let textBodeArr = textBody.split('\n');
            if (textBodeArr.length) {
              textBodeArr.forEach(el => {
                paragraph =  new docx.Paragraph(el);
                doc.addParagraph(paragraph);
              });
            }
          }
          paragraph =  new docx.Paragraph('');
          doc.addParagraph(paragraph);
          if (this.inviteUrl) {
            // paragraph =  new docx.Paragraph(this.websiteLink + 'invite?hash=' + user[ 0 ].activeCode);
            if (user[ 0 ].activeCode) {
              let text = this.translate.instant('active_code_information');
              paragraph =  new docx.Paragraph(text);
            } else {
              let text = this.translate.instant('no_active_code_information');
              paragraph =  new docx.Paragraph(text);
            }
            doc.addParagraph(paragraph);
            if (user[ 0 ].activeCode) {
              paragraph =  new docx.Paragraph('');
              let code = new docx.TextRun(user[ 0 ].activeCode).bold().size(32);
              paragraph.addRun(code);
              doc.addParagraph(paragraph);
            }
            paragraph =  new docx.Paragraph('');
            doc.addParagraph(paragraph);
          }
          if (this.end) {
            paragraph =  new docx.Paragraph(this.end);
            doc.addParagraph(paragraph);
          }
          if (this.showRegisterQrCodes) {
            if (this.registerQrCode) {
              doc.createImage(this.registerQrCode, 150, 150);
            }
          }
          if (i !== this.usersForSend.length - 1) {
            doc.createParagraph('').pageBreak();
          }
        }
      }
    }

    let packer = new docx.Packer();
    packer.toBlob(doc).then(blob => {
      console.log(blob);
      fileSaver.saveAs(blob, 'serial.docx');
      console.log('Document created successfully');
    });
  }

  toDataURL(url, callback) {
    let xhr = new XMLHttpRequest();
    xhr.onload = function() {
      let reader = new FileReader();
      reader.onloadend = function() {
        callback(reader.result);
      };
      reader.readAsDataURL(xhr.response);
    };
    xhr.open('GET', url);
    xhr.responseType = 'blob';
    xhr.send();
  }

  saveTemplate (name) {
    let body = {};
    if (this.action === 'mail') {
      body = {
        description: this.description ,
        typeOfMessage: this.typeOfMessage ,
        subject: this.subject ,
        body: this.body ,
        body1: this.mailBody1 ,
        body2: this.mailBody2 ,
        body3: this.mailBody3
      };
    }
    if (this.action === 'sms') {
      body = {
        description: this.description ,
        text: this.text ,
      };
    }
    if (this.action === 'serial') {
      body = {
        description: this.description ,
        text: this.text ,
        end: this.end ,
        welcome: this.welcome ,
        date: this.date ,
        organizationLogo: this.organizationLogo ,
        userInfo: this.userInfo
      };
    }

    const data = {
      data: JSON.stringify(body) ,
      template: 1 ,
      name: name,
      type: this.action ,
      description: this.description ,
    };
    if (!data.name) {
      delete(data.name);
    }
    if (this.spec === 'template') {
      data[ 'id' ] = this.id;
    }
    this.userService.saveTeplate(data).subscribe((res) => {
      this.toastr.success('Template saved' , 'Success!');
      this.dialogRef.close();
    });
  }
  openDialog () {
    const dialogRef = this.dialog.open(DialogName , {
      width: '250px' ,
      data: {name: ''}
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
         this.saveTemplate(result);
      }
    });
  }

  deleteTemplate() {
    this.userService.deleteTeplate(this.id).subscribe((res) => {
      this.toastr.success('Template deleted' , 'Success!');
      this.dialogRef.close();
    });
  }

  getRegistrationQrCode() {
    this.communicationService.registrationQrCode().subscribe((code: any) => {
      if (code) {
        this.registerQrCode = code.img;
      }
    });
  }

  removeReactiveKeyword(data, type, form) {
    const index = this[type].indexOf(data);
    if (index >= 0) {
      this[type].splice(index, 1);
    }
    this[form].patchValue(this[type]);
  }

  addReactiveKeyword(event: MatChipInputEvent, type, form): void {
    const value = (event.value || '').trim();
    if (value) {
      this[type].push(value);
    }
    event.chipInput!.clear();
    this[form].patchValue(this[type]);
  }

  getInviteQrCodes(userInfo) {
    let _codes: any = [];
    userInfo.forEach(el => {
      if (el.id && el.activeCode) {
        _codes.push({
          id: el.id,
          code: el.activeCode
        });
      }
    });
    this.communicationService.inviteQrCodes({users: _codes}).subscribe((codes: any) => {
      if (codes) {
        this.inviteQrCodes = codes;
      }
    });
  }

}


@Component({
    selector: 'dialog-name',
    templateUrl: 'dialog-name.html',
    standalone: false
})
export class DialogName {

  constructor (public dialogRef: MatDialogRef<DialogName> ,
               @Inject(MAT_DIALOG_DATA) public data) {
  }

  onNoClick (): void {
    this.dialogRef.close();
  }

}
